// extracted by mini-css-extract-plugin
module.exports = {"link":"AgreementWindow_link__3fq6V","textWrapper":"AgreementWindow_textWrapper__1hahk"};